module.exports = __webpack_public_path__ + "static/media/senny.cf3ab93e.png";